var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMeal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43AF49",
    fillRule: "evenodd",
    d: "M4.818 8.94l2.369-2.367L1.312.707c-1.305 1.305-1.305 3.422 0 4.736l3.506 3.498zm5.674-1.514c1.28.594 3.08.176 4.41-1.155 1.598-1.598 1.908-3.89.677-5.12-1.221-1.222-3.514-.921-5.12.677-1.331 1.33-1.75 3.13-1.155 4.41l-8.167 8.167 1.18 1.18 5.765-5.749 5.757 5.757 1.18-1.18-5.757-5.757 1.23-1.23z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meal.a66d56e9.svg";
export { ForwardRef as ReactComponent };